import { memo, useMemo } from 'react'
import { Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { Score } from 'types/games'

type Props = {
    data: Score[]
    loading: boolean
}

export const LeagueScoreTable = memo((props: Props) => {
    const { data, loading } = props

    const columns: ColumnsType<Score> = useMemo(
        () => [
            {
                title: 'Position',
                key: 'position',
                render: (_, record, index) => index + 1,
            },
            {
                title: 'TeamId',
                dataIndex: 'team',
                key: 'team',
            },
            {
                title: 'Team name',
                dataIndex: 'teamName',
                key: 'teamName',
            },
            {
                title: 'Played games',
                dataIndex: 'played',
                key: 'played',
            },
            {
                title: 'Wins',
                dataIndex: 'wins',
                key: 'wins',
            },
            {
                title: 'Draws',
                dataIndex: 'draws',
                key: 'draws',
            },
            {
                title: 'Lost',
                dataIndex: 'lost',
                key: 'lost',
            },
            {
                title: 'Goals scored',
                dataIndex: 'homeScore',
                key: 'homeScore',
            },
            {
                title: 'Goals conceded',
                dataIndex: 'awayScore',
                key: 'awayScore',
            },
            {
                title: 'Goals diff',
                dataIndex: 'goalDiff',
                key: 'goalDiff',
            },
            {
                title: 'Score',
                dataIndex: 'score',
                key: 'score',
            },
        ],
        []
    )

    return <Table loading={loading} columns={columns} dataSource={data} rowKey='id' pagination={false} />
})
